<template>
  <div>
    <form-field-datetime-picker
      v-model="form.due_at"
      :validation-errors="validationErrors.due_at"
      is-inline
    ></form-field-datetime-picker>
  </div>
</template>

<script>
  import {FormMixin} from "./forms.mixin";

  export default {
    name: "ChangeRecordDutAtForm",
    props: ['formData'],
    mixins: [FormMixin],
    data() {
      return {
        form: {},
        validationErrors: {},
        defaultForm: {
            due_at: '',
        },
      }
    },
    created() {
      // This allows you to pass in formData without an id in order to add data to the defaultForm for the the create
      this.form = this.$utils.clone(this.formData)
    },
    methods: {
      update() {
        return this.$api.records.changeActiveStatusDueAt(this.form.record_id, this.form.due_at)
          .then(res => {
            this.$buefy.toast.open({
              message: 'Lead Status due at has been updated',
              type: 'is-success'
            });

            return res;
          });
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>
